// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__38mf0","head":"Table_head__1t_rk","col":"Table_col__3zQz3"};